/** ULID-basierte Source-ID `src_<ULID>` (Browser: crypto.getRandomValues). */
const CROCKFORD = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';

export function newSourceId(now: number = Date.now()): string {
  let t = now;
  let time = '';
  for (let i = 0; i < 10; i++) {
    time = CROCKFORD[t % 32] + time;
    t = Math.floor(t / 32);
  }
  const rnd = new Uint8Array(16);
  globalThis.crypto.getRandomValues(rnd);
  let rand = '';
  for (let i = 0; i < 16; i++) rand += CROCKFORD[(rnd[i] as number) % 32];
  return `src_${time}${rand}`;
}
